import './style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import { useNavigate } from 'react-router-dom';

export const ContactComplete = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="contactComplete">
        <div className="contactComplete_wrapper">
          <Description
            label="お問い合わせを受け付けました。"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
          />
          <Description
            label="弊社にて確認後、営業担当よりご連絡差し上げますので、少々お待ちください。"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
          />
        </div>
        <Button
          label="HOMEに戻る"
          buttonFill={ButtonFill.link}
          buttonSize={ButtonSize.extraLarge}
          onClick={() => navigate(PagePath.Home)}
        />
      </div>
    </>
  );
};
